__turbopack_context__.v({
  "headerLink": "Header-module__4WBPXG__headerLink",
  "headerLinks": "Header-module__4WBPXG__headerLinks",
  "headerLogo": "Header-module__4WBPXG__headerLogo",
  "hideOnNarrow": "Header-module__4WBPXG__hideOnNarrow",
  "inner": "Header-module__4WBPXG__inner",
  "isSubscribed": "Header-module__4WBPXG__isSubscribed",
  "notificationIcon": "Header-module__4WBPXG__notificationIcon",
  "root": "Header-module__4WBPXG__root",
});
